import React, { useEffect, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { ArrowRight, Book } from "react-bootstrap-icons";
import { useParams, useHistory } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Label,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { CSVLink, CSVDownload } from "react-csv";

import Header from "../../../components/Headers/Header";
import Image from "../../../components/utils/Image";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";
import DashboardStatCard from "../../../components/Cards/Dashboard/DashboardStatCard";

import useUserRole from "../../../Hooks/useUserRole";
import { createMarkup } from "../../../Services/utils";
import {
  getAssessmentDetails,
  getAssessmentStats,
  getNoOfStudents,
} from "../../../Services/Assessment/AssessmentService";
import {
  TypeAssessment,
  TypeAssessmentDetails,
  TypeDirectUsUser,
  TypeDownloadUnattemptedList,
  TypeQuestions,
  TypeStudentAssessmentStats,
} from "../../../types";
import { PATHS, STATE_OFFICIAL_PATHS } from "../../../routes";
import { useSelector } from "react-redux";
import { State } from "../../../Reducers/types";
import Options from "../../StateOfficial/Assessments/Components/Options";

export default function ShowAssessmentDetails() {
  const { id } = useParams();
  const history = useHistory();
  const role = useUserRole();
  const session = useSelector((state: any) => state.user.session);

  // --- Questions MODAL CONTROL STATES ---
  const [questionModal, setQuestionModal] = useState(false);
  const questionsModalToggler = () => setQuestionModal(!questionModal);
  // --- UNATTEMPTED STUDENT LIST ---
  const [studentsModal, setStudentsModal] = useState(false);
  const toggleStudentModal = () => setStudentsModal(!studentsModal);

  const [assessmentInfo, setAssessmentInfo] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOptionOpen, setIsOptionOpen] = useState<number>(-1);
  const [showOptions, setShowOptions] = useState<boolean[]>([]); // for options of particular question to be shown
  // toggles value to show options of particular question
  const showOptionToggler = (index) => {
    let array = showOptions;
    array[index] = !array[index];
    setShowOptions(array);
  };

  // holds stats for available assessment
  const [assessmentStats, setAssessmentStats] =
    useState<TypeStudentAssessmentStats>({
      total: 0,
      progress: 0,
      attempted: 0,
      unattempted: 0,
      averageScore: 0,
    });
  const [unattemptedList, setUnattemptedList] = useState<TypeDirectUsUser[]>(); // holds the student list who did't attempt the assessment yet
  const [downloadData, setDownloadData] =
    useState<TypeDownloadUnattemptedList>(); // holds unattempted student list fot CSV download

  useEffect(() => {
    getDetails();
    // console.log(id, role);
  }, [id]);
  useEffect(() => {
    console.log("Re-render");
  }, [showOptions]);

  // fetch assessment details
  const getDetails = () => {
    setIsLoading(true);
    getAssessmentDetails(session?.id, id)
      .then(
        (response: AxiosResponse) => {
          console.log("Assessment Details", response?.data);
          setAssessmentInfo(response?.data);
        },
        (error: AxiosError) => {
          console.log("Assessment Details Error", error?.response);
        }
      )
      .finally(() => setIsLoading(false));
    // getAssessmentDetails(id)
    //   .then(
    //     (response: AxiosResponse) => {
    //       console.log(
    //         "Response for assessment details: ",
    //         response?.data?.data
    //       );
    //       setAssessmentDetails(response?.data?.data);
    //       getTotalStudents(response?.data?.data?.grade?.id); // fetch total number of students
    //       getAssessmentStatDetails(response?.data?.data?.id); // fetch assessment stats
    //       // setShowOptions(new Array(response?.data?.data?.questionlist?.length).fill(false));
    //       setIsLoading(false);
    //     },
    //     (error) => {
    //       console.log("Error caught: ", error?.response);
    //       toast.error("Can not show assessment details!");
    //       setIsLoading(false);
    //     }
    //   )
    //   .catch((error) => {
    //     console.log("Catched error ---> ", error);
    //     setIsLoading(false);
    //   });
  };

  // fetch total number of students assigned to a particular assessment
  const getTotalStudents = (gradeSectionId: number) => {
    getNoOfStudents(gradeSectionId)
      .then(
        (response: AxiosResponse) => {
          // console.log("Response for total number of students: ", response?.data?.meta?.filter_count, response?.data?.data);
          setAssessmentStats((oldData) => ({
            ...oldData,
            total: response?.data?.meta?.filter_count,
          })); // sets total number of students
        },
        (error) => {
          console.log("Error caught: ", error?.response);
        }
      )
      .catch((error) => console.log("Catched error ---> ", error));
  };

  // fetch and calculate assessment stats (attempted, not-attempted, in-progress)
  const getAssessmentStatDetails = (assessmentId: number) => {
    getAssessmentStats(assessmentId)
      .then(
        (response: AxiosResponse) => {
          // console.log("Response for assessment stats: ", response?.data?.data);
          response?.data?.data?.forEach((each) => {
            each?.current_status === "attempted" &&
              setAssessmentStats((oldData) => ({
                ...oldData,
                attempted: (oldData.attempted += 1),
              }));
            each?.current_status === "progress" &&
              setAssessmentStats((oldData) => ({
                ...oldData,
                progress: (oldData.progress += 1),
              }));
            each?.current_status === "unattempted" &&
              setAssessmentStats((oldData) => ({
                ...oldData,
                unattempted: (oldData.unattempted += 1),
              }));
          });
          setAssessmentStats((oldData) => ({
            ...oldData,
            total: oldData.attempted + oldData.progress + oldData.unattempted,
          })); // sets stats

          let average_score: number = Number(
            (
              response?.data?.data?.reduce(
                (accu, { total_score }) => (accu += total_score),
                0
              ) / response?.data?.data?.length
            ).toFixed(2)
          );
          setAssessmentStats((oldData) => ({
            ...oldData,
            averageScore: average_score,
          })); // sets average score of the assessment

          let unattempted = response?.data?.data
            ?.filter(
              (each: TypeAssessment) => each?.current_status === "unattempted"
            )
            .map((e) => e?.student);
          setUnattemptedList(unattempted); // sets unattempted student list

          // form data to download CSV
          let listData = unattempted?.map((each) => {
            return {
              name: each?.first_name + " " + each?.last_name,
              email: each?.email,
            };
          });
          let header = [
            { label: "Name", key: "name" },
            { label: "Email", key: "email" },
          ];
          setDownloadData((oldData) => ({
            ...oldData,
            data: listData,
            headers: header,
          }));
        },
        (error) => {
          console.log("Error catched: ", error?.response);
        }
      )
      .catch((error) => console.log("Catched error ---> ", error));
  };

  return (
    <React.Fragment>
      <Header />

      <Container className="mt--9" fluid>
        <Row>
          <Col lg="3" md="6" sm="12">
            <DashboardStatCard
              title={"Assigned Students"}
              stats={assessmentInfo?.assessment_details[0]?.assigned_students}
              icon={"fas fa-user-graduate text-muted"}
              iconBg={""}
              iconColor={""}
              label={"Students assigned"}
            />
          </Col>
          <Col lg="3" md="6" sm="12">
            <DashboardStatCard
              title={"Attempted Students"}
              stats={assessmentInfo?.assessment_details[0]?.attempted_students}
              icon={"fas fa-check-circle text-muted"}
              iconBg={""}
              iconColor={""}
              label={"Students attempted"}
            />
          </Col>
          <Col lg="3" md="6" sm="12">
            <DashboardStatCard
              title={"Unattempted Students"}
              stats={
                assessmentInfo?.assessment_details[0]?.unattempted_students
              }
              icon={"fas fa-times-circle text-muted"}
              iconBg={""}
              iconColor={""}
              label={"Students unattempted"}
            />
          </Col>
          <Col lg="3" md="6" sm="12">
            <DashboardStatCard
              title={"Average Marks"}
              stats={assessmentInfo?.assessment_details[0]?.average_marks}
              icon={"fas fa-tasks text-muted"}
              iconBg={""}
              iconColor={""}
              label={"Average Markss"}
            />
          </Col>
        </Row>
      </Container>

      <Container className="mt-3" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0 d-flex justify-content-between align-items-center">
            <h3 className="mb-0 text-muted">
              <i className="fas fa-pencil-ruler mr-1"></i> Details
            </h3>
            {/* {assessmentStats.averageScore ? <p className="font-weight-bold">Average Marks: {assessmentStats?.averageScore}</p> : <></>} */}
            <Button
              size="sm"
              color="secondary"
              onClick={() => history.push(PATHS.showAssessments)}
            >
              Go Back <ArrowRight />
            </Button>
          </CardHeader>

          <CardBody className="overflow-auto pt-0" style={{ maxHeight: 600 }}>
            {isLoading ? (
              <DotsSpinner />
            ) : (
              <ListGroup className="mb-2">
                <ListGroupItem className="shadow-none">
                  <ListGroupItemHeading className="d-flex justify-content-end align-items-center text-muted">
                    {/* <span className="d-flex align-items-center"><i className="fas fa-question-circle pr-1" style={{ fontSize: 18 }}></i> Assessment</span> */}
                    <div>
                      <Badge color="info text-dark mr-2">
                        No. of Questions:{" "}
                        {assessmentInfo?.assessment_details[0]?.no_of_questions}
                      </Badge>
                      <Badge color="info mr-2 text-dark">
                        Total Marks:{" "}
                        {Math.abs(
                          +assessmentInfo?.assessment_details[0]?.total_marks
                        )}
                      </Badge>
                    </div>
                  </ListGroupItemHeading>
                  {/* ASSESSMENT INFO */}
                  <ListGroupItemText>
                    <div>
                      <Label className="small text-muted mb-0 font-weight-bold">
                        Title:{" "}
                      </Label>
                      <p>{assessmentInfo?.assessment_details[0]?.title}</p>
                    </div>
                    <div>
                      <Label className="small text-muted mb-0 font-weight-bold">
                        Description:{" "}
                      </Label>
                      {assessmentInfo?.assessment_details[0]?.description ? (
                        <p>
                          {assessmentInfo?.assessment_details[0]?.description}
                        </p>
                      ) : (
                        <p className="text-muted small">Not Provided</p>
                      )}
                    </div>
                    <div className="w-75 d-flex justify-content-between">
                      <div>
                        <Label className="small text-muted mb-0 font-weight-bold">
                          Grade:{" "}
                        </Label>
                        <div>
                          <p>
                            {assessmentInfo?.assessment_details[0]?.other_grade}
                          </p>
                        </div>
                      </div>
                      <div>
                        <Label className="small text-muted mb-0 font-weight-bold">
                          Subject:{" "}
                        </Label>
                        <p>{assessmentInfo?.assessment_details[0]?.subject}</p>
                      </div>
                      <div>
                        <Label className="small text-muted mb-0 font-weight-bold">
                          Topic:{" "}
                        </Label>
                        <div>
                          {
                            <ul>
                              {assessmentInfo?.assessment_topics?.map(
                                (each, index) => (
                                  <li key={index}>{each?.name}</li>
                                )
                              )}
                            </ul>
                          }
                        </div>
                      </div>
                    </div>

                    <div className="w-50 d-flex justify-content-between">
                      <div>
                        <Label className="small text-muted mb-0 font-weight-bold">
                          Start Date:{" "}
                        </Label>
                        <p>
                          {moment(
                            assessmentInfo?.assessment_details[0]?.start_date
                          ).format("MMM Do YYYY - hh:mm a")}
                        </p>
                      </div>
                      <div>
                        <Label className="small text-muted mb-0 font-weight-bold">
                          End Date:{" "}
                        </Label>
                        <p>
                          {moment(
                            assessmentInfo?.assessment_details[0]?.end_date
                          ).format("MMM Do YYYY - hh:mm a")}
                        </p>
                      </div>
                    </div>
                  </ListGroupItemText>

                  <Button
                    color="info"
                    size="sm"
                    className="float-right"
                    onClick={questionsModalToggler}
                  >
                    View Questions
                  </Button>
                  {/* {unattemptedList?.length !== 0 && <Button
                                    color="danger"
                                    size="sm"
                                    className="float-right mr-2"
                                    onClick={toggleStudentModal}
                                >Unattempted List</Button>} */}

                  {/* QUESTION-OPTION MODAL */}
                  <Modal
                    isOpen={questionModal}
                    toggle={questionsModalToggler}
                    size="lg"
                    scrollable={true}
                  >
                    <ModalHeader toggle={questionsModalToggler}>
                      Question List
                    </ModalHeader>
                    <ModalBody>
                      {assessmentInfo?.assessment_questions?.map(
                        (each, index: number) => {
                          return (
                            <React.Fragment key={index}>
                              <ListGroup className="mb-2">
                                <ListGroupItem className="bg-gradient-info">
                                  <ListGroupItemHeading className="d-flex justify-content-between align-items-center text-muted">
                                    <span className="d-flex align-items-center text-white">
                                      <Book className="mr-1" size="15" />{" "}
                                      Question {index + 1}
                                    </span>
                                    <div>
                                      <Badge
                                        color="light"
                                        className="bg-white text-dark mr-2"
                                      >
                                        Marks: {each?.score}
                                      </Badge>
                                      <Badge
                                        color="light"
                                        className="bg-white text-dark"
                                      >
                                        Difficulty:{" "}
                                        {each?.difficulty_level_1_3 === 1
                                          ? "Easy"
                                          : each?.difficulty_level_1_3 === 2
                                          ? "Medium"
                                          : "Hard"}
                                      </Badge>
                                    </div>
                                  </ListGroupItemHeading>
                                  <ListGroupItemText>
                                    <p className="font-weight-bold text-white">
                                      <span
                                        dangerouslySetInnerHTML={createMarkup(
                                          each?.question
                                        )}
                                      />
                                    </p>
                                    <div
                                      className="text-white pointer"
                                      onClick={() => {
                                        if (isOptionOpen === index) {
                                          showOptionToggler(-1);
                                          setIsOptionOpen(-1);
                                        } else {
                                          showOptionToggler(index);
                                          setIsOptionOpen(index);
                                        }
                                      }}
                                    >
                                      <u>
                                        {isOptionOpen === index
                                          ? "Hide"
                                          : " View"}{" "}
                                        Options:
                                      </u>{" "}
                                    </div>
                                    {/* <Collapse isOpen={showOptions[index]}> */}
                                    {isOptionOpen === index ? (
                                      <Options questionData={each} />
                                    ) : (
                                      <></>
                                    )}
                                    {/* </Collapse> */}
                                  </ListGroupItemText>
                                </ListGroupItem>
                              </ListGroup>
                            </React.Fragment>
                          );
                        }
                      )}
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" onClick={questionsModalToggler}>
                        Close
                      </Button>
                    </ModalFooter>
                  </Modal>

                  {/* UNATTEMTED STUDENT LIST */}
                  <Modal
                    isOpen={studentsModal}
                    toggle={toggleStudentModal}
                    size="lg"
                    scrollable={true}
                  >
                    <ModalHeader toggle={toggleStudentModal}>
                      Unattempted Student List
                    </ModalHeader>
                    <ModalBody>
                      {/* DOWNLOAD CSV */}
                      {unattemptedList?.length && (
                        <div className="d-flex justify-content-end align-items-center mb-2">
                          <CSVLink
                            data={downloadData?.data}
                            headers={downloadData?.headers}
                            filename={`${
                              assessmentInfo?.assessment_details[0]?.grade
                                ?.grade
                            }_${
                              assessmentInfo?.assessment_details[0]?.subject
                            }_unattemptedList_${moment().format(
                              "DD-MM-YYYY"
                            )}.csv`}
                            target="_blank"
                          >
                            Download List{" "}
                            <i className="fas fa-file-download ml-1"></i>
                          </CSVLink>
                        </div>
                      )}
                      <div>
                        <Table
                          className="align-items-center table-flush"
                          responsive
                        >
                          <thead className="thead-light">
                            <tr>
                              <th>Student</th>
                              <th>SRN Number</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {unattemptedList?.map((each, index) => (
                              <tr key={index}>
                                <th scope="row">
                                  <span
                                    className="d-flex align-items-center pointer"
                                    onClick={() => {
                                      role === 9
                                        ? history.push(
                                            STATE_OFFICIAL_PATHS.studentProfile +
                                              "/" +
                                              each?.id
                                          )
                                        : history.push(
                                            PATHS.studentProfile +
                                              "/" +
                                              each?.id
                                          );
                                    }}
                                  >
                                    <Image
                                      source={
                                        each?.avatar?.data?.thumbnails[1]?.url
                                      }
                                      size={30}
                                      classes={"rounded-circle"}
                                    />
                                    <span className="pl-1 text-primary">
                                      {each?.first_name} {each?.last_name}
                                    </span>
                                  </span>
                                </th>
                                <td>{each?.srn_no || "Not Available"}</td>
                                <td>
                                  <Badge
                                    color={
                                      each?.status === "active"
                                        ? "success"
                                        : "danger"
                                    }
                                  >
                                    {each?.status}
                                  </Badge>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" onClick={toggleStudentModal}>
                        Close
                      </Button>
                    </ModalFooter>
                  </Modal>
                </ListGroupItem>
              </ListGroup>
            )}
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
